/**
 * The query keys shared between the reads in this folder and the cache writes
 * in `tasks-cache`.
 *
 * They live here rather than beside the query that owns each one because the
 * cache writes cross between them — a task that changes has to be written to
 * the task itself and to every tasks list holding it — and importing a key
 * from the query module directly would close an import cycle and leave one
 * side `undefined` at module init.
 */

// A single task, keyed `[FETCH_TASK_QUERY_KEY, taskId]`. Seeded by every page
// of the tasks list so opening a task from the list needs no second request.
export const FETCH_TASK_QUERY_KEY = 'fetchTask';

// The paginated tasks list, keyed `[FETCH_TASKS_QUERY_KEY, query]` where the
// query is a `FetchTasksQuery`. Each page is held as a `Map<string, Task>`.
export const FETCH_TASKS_QUERY_KEY = 'fetchTasks';

// A task's events, keyed `[FETCH_TASK_EVENTS_QUERY_KEY, taskId]` and held as a
// `Map<string, TaskEvent>`.
export const FETCH_TASK_EVENTS_QUERY_KEY = 'fetchTaskEvents';

// A task's location trail, keyed `[FETCH_TASK_LOCATIONS_QUERY_KEY, taskId]`
// and held as the paginated `TaskLocations` pages the API returns, because a
// pushed location is spliced into the page it belongs to.
export const FETCH_TASK_LOCATIONS_QUERY_KEY = 'fetchTaskLocations';

// The detail read alongside a task — device, app version, battery — keyed
// `[FETCH_TASK_INFO_QUERY_KEY, taskId]`.
export const FETCH_TASK_INFO_QUERY_KEY = 'fetchTaskInfo';
